export default __webpack_public_path__ + "static/media/eraser.eda4fb39.svg";